import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Rate } from "@Shared/Components/Rate/Rate";
import React from "react";
import messages from "../messages";
import { useOrderDescription } from "../useOrderDescription";
import { ItemLine } from "./ItemLine";

export const AdvancePaymentItem = ({ order }) => {
  const { advancePayment } = useOrderDescription(order);
  return (
    <>
      {advancePayment.length > 0 && (
        <ItemLine
          title={<FormattedMessage {...messages.advancePayment} />}
          amount={
            <Rate
              cents={advancePayment[0].amountCents}
              currency={order.itemsTotalCurrency}
            />
          }
          isSubstract
        />
      )}
    </>
  );
};
